import { render } from "./JourneySearch.vue?vue&type=template&id=25530005&lang=pug"
import script from "./JourneySearch.vue?vue&type=script&lang=ts"
export * from "./JourneySearch.vue?vue&type=script&lang=ts"

import "./JourneySearch.vue?vue&type=style&index=0&id=25530005&lang=scss"
script.render = render

export default script